import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useParams } from 'react-router-dom'

import ObjetoPostalService from '@services/ObjetoPostalService'

import Table from '@base/Table'
import Toast from '@base/Toast'

import {
  verifyPagingAndSorting,
  PAGE,
  SIZE,
  DESC,
  TOTAL_ELEMENTS,
  TOTAL_PAGES,
} from '@base/Table/Utils'

import { removePagingAndSorting } from '@helpers/PaginationHelper'
import { ProcessoResolver } from "@helpers/ProcessoHelper"

export const PortariaTableView = (props) => {

  const processo = ProcessoResolver(useParams().processo);

  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(PAGE);
  const [size, setSize] = useState(props.size ? props.size : SIZE);

  const [defaultOrderBy,] = useState(props.camposDePesagem ? 'dataPesagem': 'dataRecebimento');
  const [sort, setSort] = useState([{ orderBy: defaultOrderBy, order: DESC }])
  const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
  const [totalPages, setTotalPages] = useState(TOTAL_PAGES);
  const [list, setList] = useState([]);
  const toastRef = useRef(null);

  let columns = [
    { label: 'ID', name: 'id', func: null, key: true, hidden: true },
    { label: 'Número do Objeto Postal', name: 'numeroObjetoPostal', func: null, key: false },
    { label: 'Data Recebimento', name: 'dataRecebimento', func: null, key: false },
    { label: 'Responsável pelo Recebimento', name: 'responsavelPortaria', func: null, key: false },
    { label: 'Posição na Caixa', name: 'posicaoNaCaixa', func: (c,l) => l.posicaoNaCaixa == null ? "--" : c, key: false }

  ];

  const handlePage = page => { setPage(page); props.setFiltroAtivo(true); };

  const handleRowsPerPage = (size, page) => { setPage(page); setSize(size); props.setFiltroAtivo(true); };
  const verifyOrderBy = (orderBy) => {
    if (orderBy === 'dataResolucao') {
      return 'ultimoStatus.data';
    } else {
      return orderBy;
    }
  };

  const handleSort = (orderBy, order) => {
    if (sort.find(s => s.orderBy === verifyOrderBy(orderBy))) {
      let newSort = sort.filter(s => s.orderBy !== verifyOrderBy(orderBy));
      newSort.splice(sort.indexOf(sort.find(s => s.orderBy === verifyOrderBy(orderBy))), 0, { orderBy: verifyOrderBy(orderBy), order: order })
      setSort([...newSort]);
    } else {
      setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy)), { orderBy: verifyOrderBy(orderBy), order: order }]);
    }
    props.setFiltroAtivo(true);
  }

  const handleClearSort = (orderBy) => {
    props.setFiltroAtivo(true);
    orderBy ? setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy))]) : setSort([{ orderBy: defaultOrderBy, order: DESC }])
  };

  const handleTotalPages = () => totalPages;
  const handleTotalElements = () => totalElements;

  const carregarDados = useCallback(() => {
    const f = verifyPagingAndSorting(removePagingAndSorting(props.filtros), page, size, sort, props.filtroAtivo);

    ObjetoPostalService.filtrar(processo.id, f).then(resultado => {
      let { content, number, size, totalElements, totalPages } = resultado.data;
      console.log(resultado)
      setList(content);
      setPage(number);
      setSize(size);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
      setLoading(false);

    }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Realizar os Filtros!"));
  }, [props.filtros, props.filtroAtivo, size, page, sort, processo]);

  useEffect(() => carregarDados(), [carregarDados]);

  return (
    <>
      <Toast ref={toastRef} />

      <Table
        columns={columns}
        tableData={list}
        actions={[]}
        page={page}
        handlePage={handlePage}
        handleTotalPages={handleTotalPages}
        handleTotalElements={handleTotalElements}
        rowsPerPage={size}
        handleRowsPerPage={handleRowsPerPage}
        sort={sort}
        handleSort={handleSort}
        handleClearSort={handleClearSort}
        loading={loading}
      />

    </>
  );
}

export default PortariaTableView;
